import { alias, custom, primitive, serializable } from "serializr";

export class LiveStockCommodityOverview {

    @serializable(alias('enteric_emission', primitive()))
    entericEmission?: number;

    @serializable(alias('transportation_emission', primitive()))
    transportationEmission?: number;

    @serializable(alias('scope_1_emission', primitive()))
    scope1Emission?: number;

    @serializable(alias('scope_1_and_2_emission', primitive()))
    scope1And2Emission?: number;

    @serializable(alias('scope_2_emission', primitive()))
    scope2Emission?: number;

    @serializable(alias('feed_emission', primitive()))
    feedEmission?: number;

    @serializable(alias('distribution_emission', primitive()))
    distributionEmission?: number;

    @serializable(alias('manure_management_emission', primitive()))
    manureManagementEmission?: number;

    @serializable(alias('farm_name', primitive()))
    farmName?: string;

    @serializable(alias('total_weight', primitive()))
    totalWeight?: number;

    @serializable
    year?: number;

    @serializable
    name?: string;

    @serializable(alias('image_url', primitive()))
    imageUrl?: string;

    @serializable
    status?: string;

    // Calculated property for cradleToFarmValue using custom getter
    get cradleToFarmValue(): number {
        return (
            Number(this.entericEmission ?? 0) +
            Number(this.transportationEmission ?? 0) +
            Number(this.scope1And2Emission ?? 0) +
            Number(this.feedEmission ?? 0) +
            Number(this.manureManagementEmission ?? 0)
        );
    }

    get cradleToMarketValue(): number {
        return this.cradleToFarmValue + Number(this.distributionEmission ?? 0);
    }
}